import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import LabelInfo from '../../../../../components/LabelInfo';
import { setNumberWithComma } from '../../../../../lib/common';
import './BrandAllListSummaryBox.scss';

const BrandAllListSummaryBox = (props) => {
  const { brandSummaryBox } = props;

  return (
    <Panel className="brand-all-list-summary-box">
      <div className="panel-body">
        <div className="brand-all-list-summary-box-info">
          <div className="form-wrap">
            <LabelInfo label="전체 판매점 수" info={setNumberWithComma(brandSummaryBox.storeCount)} />

            <LabelInfo label="활성중인 판매점" info={setNumberWithComma(brandSummaryBox.activeStoreCount)} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="전체 브랜드 찜 수" info={setNumberWithComma(brandSummaryBox.storeLikeCount)} />

            <LabelInfo label="전체 상품 찜 수" info={setNumberWithComma(brandSummaryBox.productLikeCount)} />
          </div>

          <div className="form-wrap">
            <LabelInfo label="전체 판매액" info={setNumberWithComma(brandSummaryBox.sumTotalPrice, '원')} />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default BrandAllListSummaryBox;
